import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { PreferredPharmacy } from '@/lib/store/api/preferredPharmacyApi'

interface ChosenPharmacyState {
    /** A pharmacy picked on the standalone search page, waiting for the page that opened it to pick it up. */
    pharmacy: PreferredPharmacy | null
}

const initialState: ChosenPharmacyState = { pharmacy: null }

/**
 * Hands a pharmacy from the pharmacy search page back to the page that opened it. It lives in memory only, so the
 * return URL stays free of pharmacy data; the receiving page takes it once and clears it.
 */
const chosenPharmacySlice = createSlice({
    name: 'chosenPharmacy',
    initialState,
    reducers: {
        pharmacyChosen: (state, action: PayloadAction<PreferredPharmacy>) => {
            state.pharmacy = action.payload
        },
        chosenPharmacyCleared: (state) => {
            state.pharmacy = null
        },
    },
})

export const { pharmacyChosen, chosenPharmacyCleared } = chosenPharmacySlice.actions
export const chosenPharmacyReducer = chosenPharmacySlice.reducer

/** Safe when the slice is missing (e.g. a stale HMR store that predated this reducer). */
export const selectChosenPharmacy = (state: { chosenPharmacy?: ChosenPharmacyState }) =>
    state.chosenPharmacy?.pharmacy ?? null
